import { CMS_SITES_LINKS_MAPPER } from '@bcf-v2-configurators/tokens/cms-sites-links-mapper/token';
import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { provideDiTokenValue } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { TranslationConfig } from '../i18n-cache';

type CmsLandingSite =
  | 'cash-out'
  | 'loyalty-points'
  | 'mobile-application'
  | 'vip-club'
  | 'player-bets-instruction'
  | 'press'
  | 'cooperation'
  | 'locals';

export type CmsLandingPageRouteFn = (cmsLandingSite: CmsLandingSite) => string;

// no slash on end
export function cmsLandingPageRoutePath(cmsLandingSite: CmsLandingSite, config?: TranslationConfig): string {
  const mapper: Record<string, string | undefined> = provideDiTokenValue(CMS_SITES_LINKS_MAPPER);

  const localMapper: Record<string, string | undefined> = {
    'loyalty-points': 'lv-points'
  };

  return `/${langRouteI18n(config)}/lp/${mapper[cmsLandingSite] ?? localMapper[cmsLandingSite] ?? cmsLandingSite}/`;
}
